export default __webpack_public_path__ + "static/media/nolike.996f365b.png";